__turbopack_context__.v({
  "button": "styles-module__YgK_oa__button",
  "default": "styles-module__YgK_oa__default",
  "iconLeft": "styles-module__YgK_oa__iconLeft",
  "text": "styles-module__YgK_oa__text",
  "white": "styles-module__YgK_oa__white",
});
